<template>
    <v-dialog
    :value="value"
    @input="(v) => v || closeCreateH2pDialog()"
    max-width="500px"
    >
    <v-card>
        <v-card-title>
          <span class="headline">h2pファイルを作成</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-container class="pb-0">
            <v-form
              ref="createH2pForm"
              v-model="createH2pFormValid"
              lazy-validation
            >
              <span>* lasを選択してください。</span>
              <v-select
                hide-details="auto"
                v-model="inputCreateH2p.las_path"
                label="lasファイル"
                :items="las_file"
                outlined
                clearable
                dense
                :rules="[v => !!v || 'lasファイルが必要です。']"
                required
              ></v-select>
              <span>* 地形データの粗密を選択してください。</span>
              <v-select
                hide-details="auto"
                v-model="inputCreateH2p.distance"
                label="粗密"
                :items="distance"
                outlined
                clearable
                dense
                :rules="[v => !!v || '粗密が必要です。']"
                required
              ></v-select>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn depressed @click="closeCreateH2pDialog">キャンセル</v-btn>
          <v-btn depressed color="primary" @click="createH2p">作成</v-btn>
        </v-card-actions>
    </v-card>
    </v-dialog>
</template>
<script>
import {store} from "@/store";
export default {
  name: "H2pCreateFileDialog",
  props: ["value", "las_file", "array_position_id", "blur_size"],
  data() {
    return {
      createH2pFormValid: true,
      inputCreateH2p: {
        las_path: null,
        distance: null,
      },
      distance: [
        { text: "密", value: 1.0},
        { text: "中間", value: 3.0},
        { text: "粗", value: 5.0},
        { text: "無し", value: '0'},
      ],
      
    };
  },
  methods: {
    createH2p() {
      if (this.$refs.createH2pForm.validate()) {
        this.axios.post("/api/h2p/h2p/", {'data': this.inputCreateH2p, 'array_position_id': this.array_position_id, 'blur_size': this.blur_size, 'type': 'h2p'})
        .then(() => {
          store.showSuccessDialog("H2Pファイルを作成中です。");
          this.closeCreateH2pDialog();
        });
      }
    },
    
    closeCreateH2pDialog() {
      this.$refs.createH2pForm.reset();
      this.$emit("input");
    },
  },
};
</script>
